import { render, staticRenderFns } from "./SystemNotificationsTable.vue?vue&type=template&id=3d541309&"
import script from "./SystemNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./SystemNotificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports